import type { PoliciesGlobalSortOption } from '@bastion/stores';

export const POLICY_SIDEBAR_SECTIONS = [
  { id: 'totals', label: 'Overview' },
  { id: 'training', label: 'Training now' },
  { id: 'recent', label: 'Finished recently' },
  { id: 'best', label: 'Best success' },
] as const;

export const DEFAULT_POLICY_SIDEBAR_SECTIONS = POLICY_SIDEBAR_SECTIONS.map(({ id }) => id);

export interface PoliciesViewState {
  sort: PoliciesGlobalSortOption;
  sidebarSections: string[];
}

const SORTS = new Set<PoliciesGlobalSortOption>([
  'created-desc', 'created-asc', 'last-run-desc', 'rollouts-desc', 'autonomy-desc', 'success-rate-desc',
]);

export function readPoliciesViewState(params: URLSearchParams): PoliciesViewState {
  const sort = params.get('sort') as PoliciesGlobalSortOption | null;
  const requested = params.has('sidebar') ? new Set(params.get('sidebar')?.split(',')) : null;
  return {
    sort: sort && SORTS.has(sort) ? sort : 'created-desc',
    sidebarSections: requested
      ? POLICY_SIDEBAR_SECTIONS.filter(({ id }) => requested.has(id)).map(({ id }) => id)
      : [...DEFAULT_POLICY_SIDEBAR_SECTIONS],
  };
}

export function writePoliciesViewState(params: URLSearchParams, state: PoliciesViewState): void {
  params.set('sort', SORTS.has(state.sort) ? state.sort : 'created-desc');
  params.set('sidebar', POLICY_SIDEBAR_SECTIONS
    .filter(({ id }) => state.sidebarSections.includes(id)).map(({ id }) => id).join(','));
}
